//Cover editor requires padding as one number so for now I calculate the average padding, MK DES-3900
export function getAveragePadding(textElement: HTMLElement, padding: string) {
  if (!padding) return 0
  let values = padding.split(/\s+/).map(parseFloat)

  if (textElement.tagName === 'H1' && textElement.parentElement?.id === 'titlewrap') {
    const parentPadding = getComputedStyle(textElement.parentElement).padding.split(/\s+/).map(parseFloat)

    values = values.map((v, i) => v + (parentPadding[i] ?? parentPadding[0] ?? 0))
  }

  return values.reduce((sum, v) => sum + v, 0) / values.length
}

export function formatDecimalNumber(numToFormat: number | string): number {
  return +parseFloat(String(numToFormat)).toFixed(5)
}

export function getNumberFontWeight(fontWeight: string): number {
  const weightMap: Record<string, number> = {
    'thin': 100,
    'hairline': 100,
    'extralight': 200,
    'extra-light': 200,
    'ultralight': 200,
    'ultra-light': 200,
    'light': 300,
    'normal': 400,
    'regular': 400,
    'medium': 500,
    'semibold': 600,
    'semi-bold': 600,
    'demibold': 600,
    'demi-bold': 600,
    'bold': 700,
    'extrabold': 800,
    'extra-bold': 800,
    'ultrabold': 800,
    'ultra-bold': 800,
    'black': 900,
    'heavy': 900,
    'extrablack': 950,
    'extra-black': 950,
    'ultrablack': 950,
    'ultra-black': 950,
    'lighter': 300,
    'bolder': 700,
  }

  const key = fontWeight.toLowerCase().replace(/\s+/g, '-')
  return weightMap[key] ?? (parseInt(fontWeight, 10) || 400)
}

export function isBackgroundTransparent(backgroundStyle: string): boolean {
  if (!backgroundStyle?.length) return true

  const style = backgroundStyle.trim().toLowerCase()

  return (
    style === 'transparent' ||
    style === 'rgba(0, 0, 0, 0)' ||
    style === 'rgb(0 0 0 / 0)' ||
    style === 'hsla(0, 0%, 0%, 0)' ||
    style === 'hsl(0 0% 0% / 0)'
  )
}

export function getTextContentWithNewLines(element: HTMLElement | null): string {
  if (!element) {
    return ''
  }

  const cloned = element.cloneNode(true) as HTMLElement

  cloned.innerHTML = cloned.innerHTML.replace(/\n/g, '').replace(/<br\s*\/?>/gi, '\n')

  return (cloned.textContent || '').trim()
}

export function normalizeBorderRadius(borderRadius: string): string {
  if (!borderRadius) {
    return '0px'
  }

  borderRadius = borderRadius
    .replace(/^border-radius\s*:\s*/i, '')
    .replace(/;$/, '')
    .trim()

  const [radiusPart] = borderRadius.split('/')
  if (!radiusPart) {
    return '0px'
  }

  const values = radiusPart.trim().split(/\s+/)

  let sum = 0
  let count = 0
  let unit = null

  for (const val of values) {
    const match = val.match(/^([\d.]+)(px|%)$/)

    if (!match || match.length < 3 || match[1] === undefined || match[2] === undefined) {
      return '0px'
    }

    const num = parseFloat(match[1])
    const currentUnit = match[2]

    if (unit === null) {
      unit = currentUnit
    } else if (unit !== currentUnit) {
      return '0px'
    }

    sum += num
    count++
  }

  if (count === 0 || !isFinite(sum)) {
    return '0px'
  }

  const avg = Math.round(sum / count)
  return `${avg}${unit}`
}
